module.exports = __webpack_public_path__ + "static/gatku-hovercard-f4053204d671a062c46022a4e8c4afaf.gif";